export function debug(...args: any[]): void {
  if (!import.meta.client) {
    return;
  }

  const { $debug } = useNuxtApp();

  if (!$debug.isEnabled) {
    return;
  }

  const PREFIX = '🐞 ~';

  if (args.length <= 2 && typeof args[0] === 'string') {
    if (typeof args[1] === 'string') {
      console.debug(`${PREFIX} ${args.join(' ')}\n\n`);
    } else if (typeof args[1] === 'number') {
      console.debug(`${PREFIX} ${args[0]}:`, args[1]);
    } else if (typeof args[1] === 'boolean') {
      console.debug(`${PREFIX} ${args[0]}:`, args[1]);
    } else if (typeof args[1] === 'object') {
      console.debug(`${PREFIX} ${args[0]}:\n\n`, args[1]);
    } else {
      console.debug(`${PREFIX} ${args[0]}\n\n`);
    }

    return;
  }

  for (const [index, arg] of args.entries()) {
    if (index === 0) {
      console.groupCollapsed(`${PREFIX} ${arg}:\n\n`);
    } else {
      console.debug(arg);
    }
  }

  console.groupEnd();
}
